















































































































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';

import { AlertaGrilla } from '@/pantallas/Camaras/Alertas/fetchAlerta';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import readXlsFile from 'read-excel-file';
import { Validator } from 'vee-validate/types/vee-validate';
import Confirmation from '@/components/Confirmation.vue';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import moment from 'moment';
import { fetchOrdenesCompra } from './fetchOrdenesCompra';
import { utils, writeFileXLSX } from 'xlsx';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import FormularioCostos from './FormularioCostos.vue';

import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
} from 'ag-grid-community';

@Component({
  components: {
    CabeceraModal,
    ModalMantenedor,
    FormFieldsContainer,
    DatePicker,
    FormularioCostos,
    MantenedorGrid,
  },
})
export default class modalCargarArchivo extends Vue {
  @Prop({ default: true }) show: boolean;
  @Prop({ default: false }) dialog: boolean;
  @Prop({ default: null }) id_orden_compra: any;
  @Prop({ default: null }) oc_flete: any;
  @Prop({}) tieneCostos: boolean;
  @Prop({}) tipoProveedorSelected: boolean;
  @Prop({}) cantidad_esperada: number;
  @Prop({}) dolarCompra: number;
  dolarCompraNuevo: any = '';
  cantidadCargados = 0;
  //@Prop({ default: null }) po_sel: any;
  gridOptions: GridOptions;
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  serverSide: any;
  mostrarModalConfirmar: boolean = false;
  precioCarga: number = 0;
  precioCargaOtros: number = 0;
  compraUnitario: any = null;
  compraTotal: any = null;
  rules = {
    required: (value: any) => !!value || 'Required.',
    numeric: (value: any) => {
      if (value != '' && value != '0') {
        return /^[0-9,.]+$/.test(value) || 'Solo se permiten números';
      } else {
        return true;
      }
    },
  };
  calcularUnitario(data: any) {
    const tipoCambio = parseFloat(data.tipoCambio);
    const nuevoUnitario = parseFloat(data.nuevoUnitario);
    const flete = parseFloat(data.flete);
    this.precioCargaOtros = 0;
    let fleteEQ;
    if (parseFloat(flete.toString()) > 0) {
      fleteEQ = flete / this.cantidad_esperada;
    } else {
      fleteEQ = parseFloat(this.oc_flete) / this.cantidad_esperada;
    }
    this.precioCarga = 0;
    for (let item of this.itemsDelExcel) {
      let equipo = item.equipo;
      let index = this.namesEq.findIndex((name: any) => name.equipo === equipo);

      if (index != -1) {
        if (parseFloat(this.dolarCompraNuevo.toString()) > 0) {
          let valorConvertido = Number(
            this.dolarCompraNuevo.toString().replace(',', '.')
          );
          item.precioUnitario =
            valorConvertido * parseFloat(this.namesEq[index].precioUnitario);
          let costoConFlete = parseFloat(item.precioUnitario) + fleteEQ;
          let precioInternacionUnitario = nuevoUnitario;
          item.fleteOc = fleteEQ.toFixed(2);
          item.precioUnitarioClp = costoConFlete;
          let costoTotal =
            parseFloat(item.precioUnitarioClp) + precioInternacionUnitario;
          this.compraUnitario = item.precioUnitarioClp;
          this.precioCarga += parseFloat(item.precioUnitarioClp) + fleteEQ;
          this.precioCargaOtros += parseFloat(costoTotal.toString());
          item.costoUnitarioTotal = costoTotal;
          this.compraTotal = item.costoUnitarioTotal;
          if (tipoCambio > 0) {
            item.costoUnitarioTotalUsd =
              this.namesEq[index].precioUnitario +
              fleteEQ / tipoCambio +
              nuevoUnitario / tipoCambio;
          } else {
            item.costoUnitarioTotalUsd = 'Falta tipo cambio';
          }
          if (this.tipoProveedorSelected) {
            item.factorImportacion =
              (
                (parseFloat(precioInternacionUnitario.toString()) /
                  costoConFlete) *
                100
              ).toFixed(2) + ' %';
          }
        } else {
          let costoConFlete =
            parseFloat(this.namesEq[index].precioUnitarioClp) + fleteEQ;
          let precioInternacionUnitario = nuevoUnitario;
          item.fleteOc = fleteEQ.toFixed(2);
          let costoTotal =
            parseFloat(this.namesEq[index].precioUnitarioClp) +
            precioInternacionUnitario;
          this.precioCarga +=
            parseFloat(this.namesEq[index].precioUnitarioClp) + fleteEQ;
          this.precioCargaOtros += costoTotal;
          item.costoUnitarioTotal = costoTotal;
          if (tipoCambio > 0) {
            item.costoUnitarioTotalUsd =
              this.namesEq[index].precioUnitario +
              fleteEQ +
              precioInternacionUnitario / tipoCambio;
          } else {
            item.costoUnitarioTotalUsd = 'Falta tipo cambio';
          }
          if (this.tipoProveedorSelected) {
            item.factorImportacion =
              ((precioInternacionUnitario / costoConFlete) * 100).toFixed(2) +
              ' %';
          }
        }
      }
    }

    this.loadRows(this.itemsDelExcel);
  }

  verifyCosts() {
    if (!this.costos) {
      this.mostrarModalConfirmar = true;
      return;
    }
    if (
      (this.costos &&
        parseFloat(this.costos.formFields.totalOtros.value) <= 0) ||
      parseFloat(this.costos.formFields.precioDolar.value) == 0
    ) {
      this.$snotify.error(
        'Por favor agregue costos de importación y tipo de cambio'
      );
      return;
    }
    this.mostrarModalConfirmar = true;
  }

  async confirmCallback(data: boolean) {
    this.mostrarModalConfirmar = false;
    if (data) {
      let costos = false;
      if (this.tipoProveedorSelected) {
        this.updateDolar();
        costos = await this.costos.postCostos();
      } else {
        costos = true;
      }
      if (costos) {
        this.subirExcel();
      }
    }
  }

  updateDolar() {
    return fetchOrdenesCompra(
      {
        compratotal: this.compraTotal,
        compraunitario: this.compraUnitario,
        compranumero: this.id_orden_compra,
        precioDolarNuevo: Number(
          this.dolarCompraNuevo.toString().replace(',', '.')
        ),
      },
      'conectaOrdenesCompra/updateDolar'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
        }
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }
  archivoB64: any = '';
  fileName: any = '';

  pasoActivoIndex = 1;
  pasos = {
    informacionGeneral: {
      accion: 'Crear - Información General',
      visible: true,
      step: 1,
    },
  };

  showInfo: boolean = true;
  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();
  showReporteGenerado: boolean = false;
  texto_reporte: string = 'TEXTO CUERPO MODAL';

  handleInfoGeneral() {
    this.showInfo = true;
  }
  costos: any;
  mounted() {
    this.costos = this.$refs.formCostos;
    this.preLoadExcel();
  }

  getUserID(): any {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;
    return id;
  }

  closeModal() {
    this.fileName = '';
    this.archivoB64 = '';
    this.$emit('modalOrdenCompraEmit', false);
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }

  async handleGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridApi.setRowData([]);
    this.gridApi.setDomLayout('autoHeight');
  }

  async loadRows(data: Array<any>) {
    this.gridApi.setRowData(data);
    this.gridApi.setDomLayout('autoHeight');
  }

  formatMoney(params: any) {
    const numericValue = parseFloat(params.value);
    if (!isNaN(numericValue)) {
      return numericValue
        .toFixed(2)
        .replace('.', ',')
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
    return params.value;
  }

  constructor() {
    super();
    this.columnDefs = [
      {
        headerName: 'Equipo',
        field: 'equipo',
        resizable: true,
        sortable: true,
        width: 400,
        lockPinned: true,
      },
      {
        headerName: 'Serie',
        field: 'serie',
        resizable: true,
        sortable: true,
        width: 400,
        lockPinned: true,
      },
      {
        headerName: 'Imei',
        field: 'imei',
        resizable: true,
        sortable: true,
        width: 300,
        lockPinned: true,
      },
      {
        headerName: 'Costo Unitario',
        field: 'precioUnitario',
        resizable: true,
        sortable: true,
        width: 300,
        lockPinned: true,
        valueFormatter: this.formatMoney,
      },
      {
        headerName: 'Costo Flete OC',
        field: 'fleteOc',
        resizable: true,
        sortable: true,
        width: 300,
        lockPinned: true,
        valueFormatter: this.formatMoney,
      },
      {
        headerName: 'Costo Unitario CLP Con Flete',
        field: 'precioUnitarioClp',
        resizable: true,
        sortable: true,
        width: 300,
        lockPinned: true,
        valueFormatter: this.formatMoney,
        hide: true,
      },
      {
        headerName: 'Nuevo Costo Unitario CLP',
        field: 'costoUnitarioTotal',
        resizable: true,
        sortable: true,
        width: 300,
        lockPinned: true,
        valueFormatter: this.formatMoney,
        hide: true,
      },
      {
        headerName: 'Nuevo Costo Unitario USD',
        field: 'costoUnitarioTotalUsd',
        resizable: true,
        sortable: true,
        width: 300,
        lockPinned: true,
        valueFormatter: this.formatMoney,
        hide: true,
      },
      {
        headerName: 'Factor De Importación',
        field: 'factorImportacion',
        resizable: true,
        sortable: true,
        width: 300,
        lockPinned: true,
        hide: true,
      },
    ];

    this.gridOptions = {
      pagination: true,
      paginationPageSize: 25, //Solución Paginación
      //cacheBlockSize: 50, //Solución Paginación
      //paginationAutoPageSize: false,
      rowModelType: 'normal',
      columnDefs: this.columnDefs,
      //rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,
      rowSelection: 'single',
      columnTypes: {
        fecha: {
          //cellRenderer: this.fechaFilter,
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
      suppressCsvExport: true,
      suppressExcelExport: true,
      onGridReady: this.handleGridReady,

      processCellForClipboard: ({ value }) => {
        return value instanceof moment
          ? this.formatFecha(value as moment.Moment)
          : value;
      },
      onGridSizeChanged: event => {
        //event.api.sizeColumnsToFit();
      },
    };
  }
  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }
  itemsDelExcel: Array<any> = [];
  showSeries: boolean = false;
  /* preparamos el archivo dejandolo en un string de base64  */
  errorArchivo: boolean = true;
  prepare_file_upload() {
    const input = document.getElementById(
      'archivoExcel'
    ) as HTMLInputElement | null;
    if (input != null && input.files) {
      this.fileName = input.files[0].name;
      const file = input.files[0];
      const reader = new FileReader();
      let rawImg;
      reader.onloadend = () => {
        rawImg = reader.result;
        this.archivoB64 = rawImg;
      };
      reader.readAsDataURL(file);
      readXlsFile(input.files[0])
        .then((rows: any) => {
          let datos: any = [...rows];
          if (datos.length == 0) {
            this.$snotify.warning(
              'Se espera que la primera columna tenga el título "Equipo", "Serie" y si es necesario "Imei"'
            );
            this.errorArchivo = true;
            return;
          }
          let firtsRow: any = datos[0] || '';
          if (firtsRow[0].toLowerCase() != 'equipo') {
            this.$snotify.warning(
              'Se espera que la primera columna tenga el título "Equipo", "Serie" y si es necesario "Imei"'
            );
            this.errorArchivo = true;
            return;
          }
          datos = datos.splice(1);
          if (!datos[0]) {
            this.$snotify.warning(
              'Se espera que la primera columna tenga el título "Equipo", "Serie" y si es necesario "Imei"'
            );
            this.errorArchivo = true;
            return;
          }
          this.itemsDelExcel = datos.map((item: any) => {
            return {
              equipo: item[0] || '',
              serie: item[1] || '',
              imei: item[2] || '',
            };
          });
          this.quantitiesValidator();
          this.showSeries = true;
          this.loadRows(this.itemsDelExcel);
          this.errorArchivo = false;
        })
        .catch((e: any) => {
          this.itemsDelExcel = [];
        });
    }
  }
  mostrarModalErrores: boolean = false;
  arrayError: Array<string> = [];
  async quantitiesValidator() {
    await this.preLoadExcel();
    this.arrayError = [];
    let fila: number = 2;
    if (this.tipoProveedorSelected) {
      this.columnApi.setColumnVisible('factorImportacion', true);
      this.columnApi.setColumnVisible('costoUnitarioTotalUsd', true);
      this.columnApi.setColumnVisible('precioUnitarioClp', true);
      this.columnApi.setColumnVisible('costoUnitarioTotal', true);
    }
    let fleteEQ = parseFloat(this.oc_flete) / this.cantidad_esperada;
    if (fleteEQ > 0) {
      this.columnApi.setColumnVisible('fleteOc', true);
      this.columnApi.setColumnVisible('costoUnitarioTotal', true);
    }
    for (let item of this.itemsDelExcel) {
      let equipo = item.equipo;
      let index = this.namesEq.findIndex((name: any) => name.equipo === equipo);
      if (index != -1) {
        item.precioUnitario = this.namesEq[index].precioUnitario;
        if (fleteEQ > 0) {
          item.fleteOc = fleteEQ.toFixed(2);
          if (!this.tipoProveedorSelected) {
            item.costoUnitarioTotal = parseFloat(
              this.namesEq[index].precioUnitario + fleteEQ
            ).toFixed(2);
          } else {
            item.costoUnitarioTotal = parseFloat(
              this.namesEq[index].precioUnitario
            ).toFixed(2);
          }
        } else {
          item.costoUnitarioTotal = this.namesEq[index].precioUnitario;
        }

        if (this.tipoProveedorSelected) {
          item.precioUnitarioClp = this.namesEq[index].precioUnitarioClp;
        }
      }
      //Caso si falta algun nombre de equipo
      if (equipo.toString().trim() === '') {
        this.arrayError.push(`Falta equipo en la fila: ${fila}`);
        continue;
      }
      //Caso cuando agregan un dispositivo inesperado
      if (index !== -1) {
        item.equipoid = this.namesEq[index].equipoid;
        this.namesEq[index].cantidadCargada =
          parseInt(this.namesEq[index].cantidadCargada) + 1;
      } else {
        let textError = `Equipo '${equipo}' no definido en Orden de Compra.`;
        if (!this.arrayError.includes(textError)) {
          this.arrayError.push(textError);
        }
        continue;
      }
      //Caso por si falta serie e imei si el nacional
      if (!this.tipoProveedor) {
        await this.checkProveedor();
      }
      //Nacional solo serie
      if (this.tipoProveedor == 'N' && item.serie.toString().trim() == '') {
        this.arrayError.push(
          `Falta Serie en Equipo '${equipo}', en la fila: ${fila}`
        );
      }
      //Internacional imei
      if (this.tipoProveedor === 'Y') {
        if (
          item.imei.toString().trim() === '' &&
          item.serie.toString().trim() === ''
        ) {
          this.arrayError.push(
            `Falta Serie e Imei en Equipo '${equipo}', en la fila: ${fila}`
          );
        } else if (item.serie.toString().trim() === '') {
          this.arrayError.push(
            `Falta Serie en Equipo '${equipo}', en la fila: ${fila}`
          );
        } else if (item.imei.toString().trim() === '') {
          this.arrayError.push(
            `Falta Imei en Equipo '${equipo}', en la fila: ${fila}`
          );
        }
      }

      fila++;
    }
    this.gridApi.setRowData(this.itemsDelExcel);
    this.gridApi.setDomLayout('autoHeight');
    this.cantidadCargados = this.itemsDelExcel.length;
    this.namesEq.forEach((name: any) => {
      if (name.cantidadCargada > name.cantidadEsperada) {
        let textError = `La cantidad de equipos '${name.equipo}' excede la cantidad definida inicialmente.`;
        if (!this.arrayError.includes(textError)) {
          this.arrayError.push(textError);
        }
      }
    });
    if (this.arrayError.length > 0) {
      this.mostrarModalErrores = true;
      this.errorArchivo = true;
    }
  }

  /* sube al MS el excel  */
  async subirExcel() {
    /* if (this.archivoB64.length <= 1) {
      return 0;
    } */
    let body: { [key: string]: any } = {
      id_orden_compra: this.id_orden_compra,
      //fileName: this.fileName,
      //archivoB64: this.archivoB64,
      extension: 'csv',
      tipo_alerta: 'CONECTA_ORDENES_COMPRA',
      tipoProveedor: this.tipoProveedor,
      id_usuario: this.getUserID(),
      id_cliente: this.getCliente(),
      modulo_id: '147',
      datos: this.itemsDelExcel,
    };
    this.loadingService.showLoading(undefined, 'btn_subirserie');
    return fetchOrdenesCompra(
      {
        clienteDefecto: this.getCliente(),
        user_id: this.getUserID(),
        body: body,
        id_usuario: this.getUserID(),
        id_cliente: this.getCliente(),
        modulo_id: '147',
      },
      'conecta_carga_masiva/sube_excel_series'
    )
      .then((data: any) => {
        //this.$snotify.success(data.data.MENSAJE_RESPUESTA);
        this.loadingService.hideLoading('btn_subirserie');
        this.texto_reporte = data.data.MENSAJE_RESPUESTA;
        this.showReporteGenerado = true;

        //this.closeModal();
        return data.data;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }

  getCliente() {
    /*  TODO VERIFICAR */
    let user = localStorage.getItem('user');
    let clienteDefecto = JSON.parse(
      localStorage.getItem('user').replace(/'/g, '"')
    ).clienteDefecto;
    return clienteDefecto;
  }

  closeReporte() {
    this.showReporteGenerado = false;
    this.texto_reporte = '';
    this.closeModal();
  }

  async getEquiposSelected() {
    this.loadingService.showLoading(undefined, 'get_equipos_selected');
    return fetchOrdenesCompra(
      {
        compra: this.id_orden_compra,
      },
      'conectaOrdenesCompra/get_equipos_selected'
    )
      .then((data: any) => {
        this.loadingService.hideLoading('get_equipos_selected');
        return data.data.data.LISTA;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }
  namesEq: any = [];
  dataRepeated: Array<any> = [];
  async preLoadExcel() {
    this.dataRepeated = [];
    let datos = await this.getEquiposSelected();
    this.namesEq = datos.map((e: any) => {
      return {
        equipoid: e.equipoid,
        equipo: e.equiponame,
        cantidadEsperada: parseInt(e.cantidad),
        cantidadCargada: parseInt(e.cargadas),
        cantidadRestante: parseInt(e.cantidad) - parseInt(e.cargadas),
        precioUnitario: parseFloat(e.precio),
        precioUnitarioClp: parseFloat(e.unitarioclp),
      };
    });
    this.validarDatos();
    this.namesEq.forEach((dato: any) => {
      for (let i = 0; i < parseInt(dato.cantidadRestante, 10); i++) {
        this.dataRepeated.push({
          Equipo: dato.equipo,
          Serie: '',
        });
      }
    });
  }

  validarDatos() {}
  tipoProveedor: String;
  async checkProveedor() {
    return fetchOrdenesCompra(
      {
        id_orden_compra: this.id_orden_compra,
        id_usuario: this.getUserID(),
        id_cliente: this.getCliente(),
        modulo_id: 147,
      },
      'conectaOrdenesCompra/check_tipoproveedor_oc'
    )
      .then((data: any) => {
        this.loadingService.hideLoading('check_tipoproveedor_oc');
        if (Number(data.data.CODIGO_RESPUESTA) > 1) {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA);
          this.tipoProveedor = null;
        } else {
          this.tipoProveedor = data.data.LISTA[0].proveedortipo;
        }
      })
      .catch((error: any) => {
        this.tipoProveedor = null;
      })
      .finally(() => {
        return null;
      });
  }

  async descargarPlantilla() {
    this.loadingService.showLoading(undefined, 'check_tipoproveedor_oc');
    if (!this.tipoProveedor) {
      await this.checkProveedor();
    }
    let headers = {};
    if (this.tipoProveedor == 'N') {
      headers = { header: ['Equipo', 'Serie'] };
    } else {
      headers = { header: ['Equipo', 'Serie', 'Imei'] };
    }
    const ws = utils.json_to_sheet(this.dataRepeated, headers);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, 'Plantilla');
    //writeFileXLSX(wb, 'SeriesOC.xlsx');
    writeFileXLSX(wb, `Plantilla_Carga_OC_${this.id_orden_compra}.xlsx`);
    this.$snotify.success('Plantilla Excel descargada con éxito');
    this.loadingService.hideLoading('check_tipoproveedor_oc');
  }

  quitarRegistro() {
    let input = document.getElementById(
      'archivoExcel'
    ) as HTMLInputElement | null;
    input = null;
    this.itemsDelExcel = [];
    this.showSeries = false;
    this.archivoB64 = '';
    this.fileName = '';
    this.cantidadCargados = 0;
    this.precioCargaOtros = 0;
  }

  formatNumber(data: string, isCalculated: boolean = false) {
    let value = data.toString().replace(/[.]/g, '');
    if (value == null || value == '') {
      value = '0';
    }
    let formated = parseFloat(value.toString().replace(',', '.'))
      .toFixed(2)
      .replace('.', ',')
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if (isNaN(parseFloat(formated))) {
      return 0;
    }
    if (!isCalculated) {
      const verifyData = (value: any) => {
        if (!value || value == '') {
          return '0';
        } else {
          let newValue = value.replace(/[.]/g, '');
          return newValue.replace(',', '.');
        }
      };
    }

    return formated;
  }
}
